export default __webpack_public_path__ + "static/media/Choose2.52fdbe2e.png";